// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3wfwi","title":"Info_title__1mDK-","selects":"Info_selects__1vJc6","requiredAsterisk":"Info_requiredAsterisk__2YBiN"};